
import Wallet3 from "../../../assets/outline/Wallet3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Wallet3Icon({ className, dataTestid = "Wallet3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wallet3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
